export default __webpack_public_path__ + "static/media/osmo.09d4240f.svg";